import api from "../services/api"
import { toast } from "react-toastify"

const getOrigins = async () => {
    try {
        const response = await api.get(`/origins`)
        const origins = response.data?.data
        return origins
    } catch (err) {
        toast.error(err?.response?.data?.message)
    }
}

export { getOrigins }